import axios from "axios";

const API = process.env.REACT_APP_API_URL;

const getToken = () => localStorage.getItem("token");

export const getAllPartenaires = async () => {
  const token = getToken();
  const res = await axios.get(`${API}/api/partenaires/allPartenaires`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  if (![200].includes(res.status)) throw new Error("getAllPartenaires failed");
  return res.data;
};

export const addPartenaire = async (payload) => {
  const token = getToken();
  const res = await axios.post(
    `${API}/api/partenaires/addPartenaire`,
    payload,
    {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    }
  );

  // back peut répondre 200 ou 201
  if (![200, 201].includes(res.status)) {
    throw new Error(`addPartenaire failed (${res.status})`);
  }
  return res.data;
};

export const updatePartenaire = async (id, payload) => {
  const token = getToken();
  const res = await axios.put(
    `${API}/api/partenaires/updatePartenaire/${id}`,
    payload,
    {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    }
  );
  if (![200].includes(res.status)) throw new Error("updatePartenaire failed");
  return res.data;
};

export const updatePartenaireOrder = async (partenaires) => {
  const token = getToken();
  const res = await axios.put(
    `${API}/api/partenaires/updatePartenaireOrder`,
    { partenaires },
    { headers: token ? { Authorization: `Bearer ${token}` } : {} }
  );
  if (![200].includes(res.status))
    throw new Error("updatePartenaireOrder failed");
  return res.data;
};

export const updatePartenaireActivation = async (id, is_active) => {
  const token = getToken();
  const res = await axios.put(
    `${API}/api/partenaires/updatePartenaireActive/${id}`,
    { is_active },
    { headers: token ? { Authorization: `Bearer ${token}` } : {} }
  );
  if (![200].includes(res.status))
    throw new Error("updatePartenaireActivation failed");
  return res.data;
};

export const updatePartenairePhoto = async (id, file) => {
  const token = getToken();
  const formData = new FormData();
  formData.append("image", file); // ⚠️ doit être "image" (multer .single("image"))

  const res = await axios.patch(
    `${API}/api/partenaires/${id}/photo`,
    formData,
    {
      headers: {
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        "Content-Type": "multipart/form-data",
      },
    }
  );

  if (![200].includes(res.status))
    throw new Error("updatePartenairePhoto failed");
  return res.data; // { imageUrl }
};

export const deletePartenaire = async (id) => {
  const token = getToken();
  const res = await axios.delete(
    `${API}/api/partenaires/deletePartenaire/${id}`,
    {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    }
  );
  if (![200].includes(res.status)) throw new Error("deletePartenaire failed");
  return res.data;
};
